import { render, staticRenderFns } from "./EditInvoicePosition.vue?vue&type=template&id=38ad0792"
import script from "./EditInvoicePosition.vue?vue&type=script&lang=ts"
export * from "./EditInvoicePosition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports